import { render, staticRenderFns } from "./VideoGalleryUpload.vue?vue&type=template&id=5bf868da&scoped=true&"
import script from "./VideoGalleryUpload.vue?vue&type=script&lang=js&"
export * from "./VideoGalleryUpload.vue?vue&type=script&lang=js&"
import style0 from "./VideoGalleryUpload.vue?vue&type=style&index=0&id=5bf868da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf868da",
  null
  
)

export default component.exports